export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "user": {
          "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Student"])},
          "myProfile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Profile"])},
          "whatIsNew": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["What's New?"])},
          "help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Help"])},
          "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Log out"])}
        }
      },
      "ru": {
        "user": {
          "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ученик"])},
          "myProfile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мой профиль"])},
          "whatIsNew": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Что нового?"])},
          "help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Помощь"])},
          "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выйти из аккаунта"])}
        }
      },
      "es": {
        "user": {
          "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alumno"])},
          "myProfile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mi perfil"])},
          "whatIsNew": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Qué hay de nuevo?"])},
          "help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ayuda"])},
          "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cerrar sesión"])}
        }
      },
      "kk": {
        "user": {
          "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оқушы"])},
          "myProfile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Менің профилім"])},
          "whatIsNew": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не жаңалық?"])},
          "help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Көмек"])},
          "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Шоттан шығу"])}
        }
      },
      "uz": {
        "user": {
          "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Talaba"])},
          "myProfile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mening profilim"])},
          "whatIsNew": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yangi nima?"])},
          "help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yordam"])},
          "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hisobdan chiqish"])}
        }
      },
      "de": {
        "user": {
          "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Schüler"])},
          "myProfile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mein Profil"])},
          "whatIsNew": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Was gibt es Neues?"])},
          "help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hilfe"])},
          "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abmelden"])}
        }
      },
      "fr": {
        "user": {
          "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Étudiant"])},
          "myProfile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mon profil"])},
          "whatIsNew": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quoi de neuf ?"])},
          "help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aide"])},
          "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se déconnecter"])}
        }
      },
      "it": {
        "user": {
          "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Studente"])},
          "myProfile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il mio profilo"])},
          "whatIsNew": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Novità?"])},
          "help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aiuto"])},
          "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Esci dall'account"])}
        }
      }
    }
  })
}
